import {
    ActionCreatorProps,
    createAction,
    props
} from '@ngrx/store';
import {
    DATIQ_LINK,
    DatiqAnalyticsInputInteraction,
    IDatiqAnalyticsEvent,
} from '@dat/datiq-core/models';

export const PREFIX = `[Datiq ${DATIQ_LINK}]`;

const createActionName: (name: string) => string = (name: string) => {
    return `${PREFIX} ${name}`;
};

const defaultProp: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const NAME_CLICK = createActionName(
    `${DatiqAnalyticsInputInteraction.Click}`
);

export const clickDatiqLink = createAction(NAME_CLICK, defaultProp);
export const clickDatiqLinkSuccess = createAction(
    createActionName('click success')
);
export const clickDatiqLinkFail = createAction(
    createActionName('click fail'),
    props<{ error: unknown }>()
);
